<template>
  <transition name="http-status-fade">
    <div v-if="showIndicator" class="http-status-floating" :class="statusClass">
      <v-icon small :color="statusColor" class="mr-2">{{ statusIcon }}</v-icon>
      <span class="status-text">{{ statusText }}</span>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HttpStatusIndicator",
  data() {
    return {
      elapsedSeconds: 0,
      intervalId: null,
    };
  },
  computed: {
    ...mapGetters({
      isActive: "http_status/isActive",
      activeRequest: "http_status/activeRequest",
      lastResult: "http_status/lastResult",
    }),
    showIndicator() {
      return this.isActive || this.lastResult;
    },
    statusClass() {
      if (this.isActive) return "status-pending";
      if (this.lastResult && this.lastResult.success) return "status-success";
      if (this.lastResult && !this.lastResult.success) return "status-error";
      return "status-pending";
    },
    statusColor() {
      if (this.isActive) return "#333333";
      if (this.lastResult && this.lastResult.success) return "#2E7D32";
      if (this.lastResult && !this.lastResult.success) return "#C62828";
      return "#333333";
    },
    statusIcon() {
      if (this.isActive) return "mdi-loading mdi-spin";
      if (this.lastResult && this.lastResult.success) return "mdi-check-circle";
      if (this.lastResult && !this.lastResult.success)
        return "mdi-alert-circle";
      return "mdi-loading";
    },
    statusText() {
      if (this.isActive && this.activeRequest) {
        return `${this.activeRequest.method} ${this.activeRequest.url}  Runtime: ${this.elapsedSeconds}s`;
      }
      if (this.lastResult) {
        const time = this.lastResult.duration.toFixed(1);
        if (this.lastResult.success) {
          return `Request completed. Time: ${time}s`;
        }
        return `${this.lastResult.errorMessage}. Runtime: ${time}s. Please Try Again.`;
      }
      return "";
    },
  },
  watch: {
    isActive(active) {
      if (active) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    },
    activeRequest(req) {
      if (req) {
        this.elapsedSeconds = 0;
      }
    },
  },
  methods: {
    startTimer() {
      this.stopTimer();
      this.elapsedSeconds = 0;
      this.intervalId = setInterval(() => {
        if (this.activeRequest) {
          this.elapsedSeconds = Math.floor(
            (Date.now() - this.activeRequest.startTime) / 1000
          );
        }
      }, 1000);
    },
    stopTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  },
  beforeDestroy() {
    this.stopTimer();
  },
};
</script>

<style scoped>
.http-status-floating {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 24px;
  font-size: 12px;
  font-weight: 500;
  font-family: "Roboto Mono", monospace;
  white-space: nowrap;
  max-width: 520px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(4px);
}

.status-pending {
  background: rgba(255, 255, 255, 0.95);
  color: #333333;
  border: 1px solid #e0e0e0;
}

.status-success {
  background: rgba(232, 245, 233, 0.95);
  color: #2e7d32;
  border: 1px solid #a5d6a7;
}

.status-error {
  background: rgba(255, 235, 238, 0.95);
  color: #c62828;
  border: 1px solid #ef9a9a;
}

.status-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.http-status-fade-enter-active,
.http-status-fade-leave-active {
  transition: all 0.3s ease;
}

.http-status-fade-enter,
.http-status-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
